import { captureException } from '@sentry/react'
import StackAPI from '../../../lib/StackAPI'
import Storage from '../../../lib/Storage'

const ENDPOINT = '/partners/insights'

export type Metric = 'ledger' | 'deductions'

const getLookerUrl = async (metric: Metric): Promise<string> => {
  const { get } = StackAPI()
  const { getActiveRole } = Storage()
  const activeRole = getActiveRole()
  const request = {
    path: `${ENDPOINT}?metric=${metric}`,
    params: {
      context: activeRole?.type?.toLowerCase()
    }
  }

  return await get(request)
    .then(({ data, status }) => (status === 200 ? data.url : 0))
    .catch((error) => {
      captureException(error, { extra: { metric } })
      return ''
    })
}

export default getLookerUrl
